export const STORE_KEY_DETAIL = 'detail'
export const STORE_KEY_SUBCATEGORY = 'subcategory'
export const STORE_KEY_EPISODE_DETAIL_NEXT = 'episodeDetailNext'
export const STORE_KEY_SHELF = 'shelf'
export const STORE_KEY_SHELF_EPISODES = 'shelfEpisodes'
export const STORE_KEY_SHELF_RELATED = 'shelfRelated'
export const STORE_KEY_SHELF_FEATURED_EPISODE = 'shelfFeaturedEpisode'
export const STORE_KEY_SHELF_EPISODES_NEXT = 'shelfEpisodesNext'
export const STORE_KEY_DETAIL_EPISODE_RELATED = 'detailEpisodeRelated'
export const STORE_KEY_DETAIL_VIDEO_RELATED = 'detailVideoRelated'
export const STORE_KEY_DETAIL_FEATURED_EPISODE = 'detailFeaturedEpisode'
export const STORE_KEY_DETAIL_PROGRESSIVE_SERIES_RELATED = 'detailProgressiveSeriesRelated'
export const STORE_KEY_MEMBER_HOME = 'memberHome'
export const STORE_KEY_DETAIL_SERIES = 'detailSeries'
export const STORE_KEY_DETAIL_SERIES_SEASON = 'detailSeason'
export const STORE_KEY_DETAIL_EPISODE = 'detailEpisode'
export const STORE_KEY_DETAIL_VIDEO = 'detailVideo'
export const STORE_KEY_VIDEO_PLAYER_NEXT = 'videoPlayerNext'
export const STORE_KEY_VIDEO_PLAYER_END_STATE = 'videoPlayerEndState'
export const STORE_KEY_VIDEO_PLAYER_HEARTS_TOOL_TIP = 'videoPlayerHeartsToolTip'
export const STORE_KEY_VIDEO_PLAYER_COMMENTS_TOOL_TIP =
  'videoPlayerCommentsToolTip'
export const STORE_KEY_MEMBER_HOME_TILE_HERO_TOOL_TIP =
  'memberHomeTileHeroToolTip'
export const STORE_KEY_PLAYLIST = 'playlist'
export const STORE_KEY_PLAYLIST_DEFAULT = 'playlistDefault'
export const STORE_KEY_SEARCH = 'search'
export const STORE_KEY_ALERT_BAR_TOP = 'alertBarTop'
export const STORE_KEY_ALERT_BAR_BOTTOM = 'alertBarBottom'
export const STORE_KEY_RECENTLY_ADDED = 'recentlyAdded'
export const STORE_KEY_WATCH_HISTORY = 'watchHistory'
export const STORE_KEY_VIEW_WATCH_HISTORY_TOOL_TIP = 'viewWatchHistoryToolTip'
export const STORE_KEY_SHARE_VIEW_LINK = 'shareUrl'
export const STORE_KEY_SHARE_VIEW_VIDEO_DETAILS = 'videoDetails'
export const STORE_KEY_SHARE_VIEW_START_TIMER = 'startTimer'
export const STORE_KEY_MEMBER_PORTAL = 'portal'
export const STORE_KEY_SHARE_VIEW_END_STATE_RELATED = 'shareViewEndStateRelated'
export const STORE_KEY_ACCOUNT_CANCEL_DISSATISFIED_RECENT = 'accountCancelDissatisfiedRecent'

